  var w = window.matchMedia("(max-width: 989px)");
  var vid = document.getElementById("vid");
  var source = document.createElement("source");
  source.id = "hvid";
  source.setAttribute("type", "video/mp4");
  vid.appendChild(source);
  
  if (w.matches) {
    vid.pause();
    source.removeAttribute("src");
    source.setAttribute("src", "https://cdn.shopify.com/videos/c/o/v/35a347bdb73d4b6a962dbb92f519947d.mp4");
    vid.load();
    vid.play();
  } else {
    vid.pause();
    source.removeAttribute("src");
    source.setAttribute("src", "https://cdn.shopify.com/videos/c/o/v/e7c19f7db8244b98b9a97634fbd08a7b.mp4");
    vid.load();
    vid.play();
  }

